



















import Vue from "vue";

export default Vue.extend({
  name: "ProjectDetailsOverlay",
  props: {
    visible: Boolean,
    color: String,
    title: String,
    htmlContent: String,
  },
  watch: {
    visible: function (isVisible: boolean) {
      if (isVisible) {
        document.addEventListener("keydown", this.onKeydown);
      } else {
        document.removeEventListener("keydown", this.onKeydown);
      }
    },
  },
  beforeDestroy: function () {
    document.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    onKeydown: function (event: KeyboardEvent) {
      if (event.key === "Escape") {
        this.$emit("close");
      }
    },
  },
});
